// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
/** 出题管理 Start*/ 
// 题库一览
import QuestionBank from '@/views/questions/QuestionBank';
// 题目一览
import Question from '@/views/questions/Question';
/** 出题管理 End*/ 

/** 计分规则 Start*/ 
// 维度管理
import WeiDu from '@/views/scoreRule/WeiDu';
// 绑定题目
import SetQuestion from '@/views/scoreRule/SetQuestion';
/** 计分规则 End*/ 

/** 用户管理 Start*/ 
// 微信用户
import WxUser from '@/views/wxUser/WxUser';
/** 用户管理 End*/ 

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
            {
                path: '/questions/QuestionBank',
                name: '题库一览',
                component: QuestionBank,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/questions/Question',
                name: '题目一览',
                component: Question,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/scoreRule/WeiDu',
                name: '维度管理',
                component: WeiDu,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/scoreRule/SetQuestion',
                name: '绑定题目',
                component: SetQuestion,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/wxUser/WxUser',
                name: '微信用户',
                component: WxUser,
                meta: {
                    requireAuth: true
                }
            }
    ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js